import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || (window.location.origin + "/auth/callback"),
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUT_URI || window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
  system: { loggerOptions: { logLevel: LogLevel.Error, piiLoggingEnabled: false } },
};

export const loginRequest = { scopes: ["openid", "profile", "email"] };
export const apiRequest   = { scopes: [process.env.REACT_APP_API_SCOPE] };
